import { zodResolver } from '@hookform/resolvers/zod';
import { merge } from 'lodash-es';
import { type FC } from 'react';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import type { ReferralFormFields } from './referralFormSchema';
import { ReferralFormSchema } from './referralFormSchema';
import { typeOfHelpDefaultValues } from './TypeOfHelpFormSection/sectionSchema';
/**
 * provides the react-hook-form context with
 * the ReferralFormFields type preset
 */
export const useReferralFormContext = () => {
  const formMethods = useFormContext<ReferralFormFields>();
  return formMethods;
};

/** default values used when data mapper does not provide a value for these fields */
const defaultValues = {
  customerProfile: {
    isMatchingComplete: 'false',
    isMaccEligible: 'false',
  },
  details: {
    currency: 'USD',
    requirements: { customerMarketplaceIntent: 'Yes' as const },
  },
  typeOfHelp: typeOfHelpDefaultValues,
};

export const ReferralFormProvider: FC<{
  initialValues?: Partial<ReferralFormFields>;
}> = ({ children, initialValues }) => {
  const initValues = merge({}, defaultValues, initialValues);
  const formMethods = useForm<ReferralFormFields>({
    defaultValues: initValues,
    mode: 'all',
    resolver: zodResolver(ReferralFormSchema),
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};
